import { VIDEO_EVENTS } from 'playable';
import { SourceType } from './Player.types';
import { PlayableWrapper } from './PlayableWrapper';
import { FBWrapper } from './FBWrapper';
import { VimeoWrapper } from './VimeoWrapper';
export let ErrorCode = /*#__PURE__*/function (ErrorCode) {
  ErrorCode["UNKNOWN"] = "UNKNOWN";
  ErrorCode["NETWORK"] = "NETWORK";
  ErrorCode["DECODE"] = "DECODE";
  ErrorCode["FORMAT"] = "FORMAT";
  ErrorCode["PLAYBACK"] = "PLAYBACK";
  ErrorCode["ERROR_SRC_PARSE"] = "error-src-parse";
  return ErrorCode;
}({});
export function toError(error) {
  return {
    name: error.name,
    message: error.message,
    code: ErrorCode.UNKNOWN
  };
}
export function getPlayerInstance(player, type) {
  switch (type) {
    case SourceType.Youtube:
      return player;
    case SourceType.Facebook:
      return new FBWrapper(player);
    case SourceType.Vimeo:
      return new VimeoWrapper(player);
    default:
      return new PlayableWrapper(player);
  }
}
//# sourceMappingURL=OPGPlayerInstance.js.map